/**
 * watchlist-item-request.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

import { Message } from "../general/message";
import { ReplyVerifyingMessage } from "../general/reply-message";
import { MessageTag } from "../message-tag";

/**
 * A client transmits a {@link WatchlistItemRequest} to request the object
 * behind a particular watchlist entry. The server responds with an {@link
 * SubjectContextResponse} that carries the opaque identifier for the
 * requested object.
 */
export class WatchlistItemRequest extends ReplyVerifyingMessage
{
  /** The unique tag for this message type */
  public tag : MessageTag = MessageTag.REQ_WATCHLIST_ITEM;
	public static tag : MessageTag = MessageTag.REQ_WATCHLIST_ITEM;

  public verifyReply (reply : Message) : boolean
  {
    return Message.isA(reply, MessageTag.RSP_SUBJECT_CONTEXT);
  }

  /**
   * Construct a new {@link WatchlistItemRequest}.
   */
  constructor (public watchId : number, public objectId : number)
  {
    super();
  }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/messages/watchlists/watchlist-item-request.ts